import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { KYMW4500Model } from '../kymw4500.model';
import { FeatureMasterInfo } from '../vo/feature-master-info';

// レスポンス構造
export type GetFeatureMasterInfoResponse = {
  ExclusiveDatetime: string;
  FeatureMasterList: FeatureMasterInfo[];
};

/**
 * 特集マスタ情報取得
 *
 * @export GetFeatureMasterInfoService
 * @class GetFeatureMasterInfoService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetFeatureMasterInfoService extends PlessJsonResponderSub<GetFeatureMasterInfoResponse> {
  private mediumType: string;
  private orderCode: string;
  private successFunc: Function;
  private model: KYMW4500Model;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetFeatureMasterInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        MediumType: this.mediumType,
        OrderCode: this.orderCode
      },
    });
  }

  /**
   * API呼び出し
   * @param model
   * @param successFunc
   * @memberof GetFeatureMasterInfoService
   */
  execute(model: KYMW4500Model, successFunc: Function = null): void {
    this.model = model;
    this.orderCode = model.orderCode;
    this.mediumType = model.mediumType;
    this.successFunc = successFunc;
    this.send('getFeatureMasterInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetFeatureMasterInfoService
   */
  success(data: GetFeatureMasterInfoResponse) {
    this.model.setFeatureMasterInfoList(data);
    if (this.successFunc) this.successFunc(data);
  }
}
